export class ReportParameters {
  companyIds: IdList[];
  deviceIds: IdList[];
  customergroupIds: IdList[];  
  fromdate: string;
  todate: string;
  vehicleNumber: string;

  //changes start by Aniruddha
  profileIds: IdList[];
  shiftIds: IdList[];
  /**
   *
   */
  constructor() {
    this.companyIds = [];
    this.deviceIds = [];
    this.customergroupIds = [];

    //changes start by Aniruddha
    this.profileIds = [];
    this.shiftIds = [];
  }
}
export class IdList {
  ID: number;
}
